export const ONLINE_PRINT_MAX_ATTEMPTS = 3;

export const getEnabledOnlinePrintTypes = ({
  customer = false,
  kitchen = false,
} = {}) => {
  const types = [];
  if (customer) types.push("customer");
  if (kitchen) types.push("kitchen");
  return types;
};

export const isDesignatedOnlinePrintTerminal = ({
  isElectron = false,
  terminalId = "",
  designatedTerminalId = "",
} = {}) =>
  Boolean(
    isElectron &&
      terminalId &&
      designatedTerminalId &&
      terminalId === designatedTerminalId,
  );

export const getOnlinePrintRetryDelay = (attempts = 1) =>
  Math.min(31000 * Math.pow(2, Math.max(attempts, 1) - 1), 121000);
